import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { queries } from "@/apollo";

import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { useQuery } from "@vue/apollo-composable";
import { useRootStore } from "@/store/pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSelectSearch',
  emits: ["update:userId"],
  setup(__props, { emit }) {

const { result, loading } = useQuery<{ me: User }>(
  queries.meWithAllDownlines,
  {},
  {
    fetchPolicy: "cache-and-network",
  }
);

const rootStore = useRootStore();


const selectedUserId = ref(rootStore.account?.userId);

const router = useRouter();
const route = useRoute();

const accountList = computed(() => {
  if (!result.value?.me) {
    return [];
  }
  const downlines = result.value.me.downlines;
  return [result.value?.me, ...downlines];
});

const routeUserId = computed(() => route.query.userId);

const accountListOptions = computed(() => {
  return accountList.value.map((u) => ({
    text: `${u.userId.toUpperCase()} [${u.username}]`,
    value: u.userId,
  }));
});

watch(routeUserId, (userId) => {
  resetUserId();
});

function resetUserId() {
  if (routeUserId.value) {
    selectedUserId.value = routeUserId.value as string;
  }
}

function selectAccount(event: Event) {
  const val = (event as Event & { value: User["userId"] }).value;
  emit("update:userId", val);
  goToAccount(val);
}

function goToAccount(userId: User["userId"]) {
  if (!route.name) {
    return;
  }
  router.push({
    name: route.name,
    query: { ...route.query, userId },
  });
}

return { __sfc: true,result, loading, rootStore, emit, selectedUserId, router, route, accountList, routeUserId, accountListOptions, resetUserId, selectAccount, goToAccount }
}

})